import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbService } from '@app/core/services/breadcrumb.service';
import { SkeletonLoadingComponent } from '@shared/components/skeleton-loading/skeleton-loading.component';

@Component({
  selector: 'cx-breadcrumb-section',
  templateUrl: './cx-breadcrumb-section.component.html',
  styleUrl: './cx-breadcrumb-section.component.scss',
  imports: [RouterLink, SkeletonLoadingComponent],
})
export class CxBreadcrumbSectionComponent {
  protected breadcrumbService = inject(BreadcrumbService);
  protected links = computed(() => this.breadcrumbService.links());
}
